import React from "react"
import {
  Box, ListItem, Text, UnorderedList,
} from "@chakra-ui/react"
import ModalForm from "components/dialogs/ReactHookForm/ModalForm"
import TextField from "components/ReactHookForm/TextField"
import { DioboxEvent } from "sharedTypes"
import * as Yup from "yup"
import ModalContentWrapper from "pages/EventShow/Forms/StyleAndConfiguration/StyleAndConfigurationModals/ModalContentWrapper"

type Props = {
  onHide: () => void
  event: DioboxEvent
  updateEvent: (params: {}) => Promise<void> | void
  onChangeEventWorkingCopy: (values: Partial<DioboxEvent>) => void
  onResetEventWorkingCopy: () => void
}

const PublicEventTitleSchema = Yup.object().shape({
  publicEventTitle: Yup.string()
    .trim()
    .required(),
})

const PublicEventTitleModal = ({
  onHide,
  event: { publicEventTitle },
  updateEvent,
  onChangeEventWorkingCopy,
  onResetEventWorkingCopy,
}: Props) => {
  const handleSubmit = async (data) => {
    await updateEvent(data)
    onHide()
  }

  const handleCancel = () => {
    onHide()
    onResetEventWorkingCopy()
  }

  return (
    <ModalForm
      size="xl"
      noPadding
      initialValues={{ publicEventTitle }}
      title="Public Event Title"
      onSubmit={handleSubmit}
      onClose={handleCancel}
      onChange={onChangeEventWorkingCopy}
      disableSubmitWhenNotDirty
      validationSchema={PublicEventTitleSchema}
    >
      {({ control }) => (
        <ModalContentWrapper>
          <Box px={6} pt={6} pb={8}>
            <Text mb={6}>
              Use a different title for public-facing areas of your event. The internal event name
              used in Diobox will remain unchanged.
            </Text>
            <Box mb={6} maxW="md">
              <TextField
                variant="outline"
                name="publicEventTitle"
                control={control}
                ariaLabel="Public event title"
              />
            </Box>
            <Text mb={2}>This title will appear on</Text>
            <UnorderedList ml={6}>
              <ListItem>Registration Forms</ListItem>
              <ListItem>Confirmation Emails</ListItem>
              <ListItem>Apple Wallet and Google Wallet Passes</ListItem>
              <ListItem>Merge Fields (Badges, Emails, and Texts)</ListItem>
              <ListItem>Kiosk Mode</ListItem>
            </UnorderedList>
          </Box>
        </ModalContentWrapper>
      )}
    </ModalForm>
  )
}

export default PublicEventTitleModal
